module.exports = __webpack_public_path__ + "img/chr_ts_20.662f961b.png";